/**
 * @see https://stackoverflow.com/questions/8648892/how-to-convert-url-parameters-to-a-javascript-object
 */
const queryStringToObject = <T extends string, V extends string>(
    query: string
): Partial<Record<T, V>> => {
    const queryWithoutQuestionMark =
        query.substring(0, 1) === '?' ? query.substring(1) : query;

    if (!queryWithoutQuestionMark) {
        return {} as Partial<Record<T, V>>;
    }

    return JSON.parse(
        `{"${decodeURI(queryWithoutQuestionMark)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')}"}`
    );
};

export default queryStringToObject;
